import KJUR from 'jsrsasign';

export const getTokenExpTimestamp = (token) => KJUR.jws.JWS.parse(token).payloadObj.exp;

export const getTokenTTLLeft = (token) => getTokenExpTimestamp(token) - KJUR.jws.IntDate.get('now');

export const getTokenPayload = (token) => (token ? KJUR.jws.JWS.parse(token).payloadObj : {});

export const isTokenExpired = (token) => getTokenTTLLeft(token) < 0;
